/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Gender } from 'app/shared/model/enumerations/gender.model';
import { createEntity, getEntity, reset, updateEntity } from './symptom.reducer';

export const SymptomUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const symptomEntity = useAppSelector(state => state.symptom.entity);
  const loading = useAppSelector(state => state.symptom.loading);
  const updating = useAppSelector(state => state.symptom.updating);
  const updateSuccess = useAppSelector(state => state.symptom.updateSuccess);
  const genderValues = Object.keys(Gender);

  const handleClose = () => {
    navigate(`/symptom${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...symptomEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          gender: 'MALE',
          ...symptomEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.symptom.home.createOrEditLabel" data-cy="SymptomCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.symptom.home.createOrEditLabel">Create or edit a Symptom</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="symptom-id"
                  label={translate('tinyMedicRestApp.symptom.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('tinyMedicRestApp.symptom.name')} id="symptom-name" name="name" data-cy="name" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptom.gender')}
                id="symptom-gender"
                name="gender"
                data-cy="gender"
                type="select"
              >
                {genderValues.map(gender => (
                  <option value={gender} key={gender}>
                    {translate(`tinyMedicRestApp.Gender.${gender}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.symptom.widgetType')}
                id="symptom-widgetType"
                name="widgetType"
                data-cy="widgetType"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptom.startDate')}
                id="symptom-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptom.endDate')}
                id="symptom-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptom.active')}
                id="symptom-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptom.draft')}
                id="symptom-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptom.cursor')}
                id="symptom-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptom.lastUpdated')}
                id="symptom-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptom.microSec')}
                id="symptom-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.symptom.timestampEntry')}
                id="symptom-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField label={translate('tinyMedicRestApp.symptom.ucid')} id="symptom-ucid" name="ucid" data-cy="ucid" type="text" />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/symptom" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SymptomUpdate;
